import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import _ from "lodash";
import Senhas from "./components/senhas";
import ListGroupLinks from "./components/common/listGroupLinks";
import { getSenhas } from "./services/senhaService";
import { getSalas } from "./services/salaService";
import Loader from "./utils/Loader";
import "./App.css";

class App extends Component {
  state = {
    salas: [],
    selectedItem: null,
    senhas: [],
    sortColumn: { path: "hora", order: "desc" },
    searchQuery: "",
    isLoading : true //2025-05-22
  };

  async componentDidMount() {

    //const salas = [{ _id: 1, name: "Estudio 1" }, { _id: 2, name: "Pista 1" }];

   try {
     const { data } = await getSalas();
     const salas = [{ _id: "", name: "Todos os espaços" }, ...data];

     const { data: senhas } = await getSenhas();

     this.setState({ salas, senhas });
     this.setState({ isLoading : false});
   } catch (error) {
       this.setState({ isLoading : false});
   }

    //const { data } = await getSalas();
    //const salas = [{ _id: "", name: "Todos os espaços" }, ...data];


    //const { data: senhas } = await getSenhas();

    //this.setState({ salas, senhas });
  }

  handleSelect = (item) => {
    this.setState({ selectedItem: item });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handleSearchQuery = (query) => {
    this.setState({ searchQuery: query });
  };

  handleSenhasRefresh = async () => {
    console.log("handleSenhasRefresh");

    try {
      this.setState({ isLoading : true});

      const { data } = await getSalas();
      const salas = [{ _id: "", name: "Todos os espaços" }, ...data];

      const { data: senhas } = await getSenhas();

      this.setState({ salas, senhas });
      this.setState({ isLoading : false});
    } catch (error) {
        this.setState({ isLoading : false});
    }


  };


  getFilteredData = () => {
    const { senhas: allSenhas, searchQuery, sortColumn } = this.state;

    let filtered = allSenhas;

    if (searchQuery)
      filtered = allSenhas.filter((s) =>
        s.nome_completo.toLowerCase().includes(searchQuery.toLowerCase())
      );

    const senhas = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    return { data: senhas };
  };

  render() {
    const { data: senhas } = this.getFilteredData();

    return (
      <div className="App">
        <Switch>
          <Route
            path="/senhas/:id"
            render={(props) => (
              this.state.isLoading ? (<Loader />) : (<Senhas
                senhas={senhas}
                sortColumn={this.state.sortColumn}
                searchQuery={this.searchQuery}
                onSort={this.handleSort}
                onChangeQuery={this.handleSearchQuery}
                onClickTotalSenhas={this.handleSenhasRefresh} //2025-05-22
                {...props}
              />)
            )}
          />
          <Route
            path="/senhas"
            render={(props) => (
              this.state.isLoading ? (<Loader />) : (<Senhas
                senhas={senhas}
                sortColumn={this.state.sortColumn}
                searchQuery={this.searchQuery}
                onSort={this.handleSort}
                onChangeQuery={this.handleSearchQuery}
                onClickTotalSenhas={this.handleSenhasRefresh} //2025-05-22
                {...props}
              />)
            )}
          />
          <Route
            path="/"
            exact
            render={(props) => (
              this.state.isLoading ? (<Loader />) : (<ListGroupLinks
                items={this.state.salas}
                selectedItem={this.state.selectedItem}
                onItemSelect={this.handleSelect}
                onRefresh={this.handleSenhasRefresh}
                {...props}
              />)
            )}
          />
          <Redirect from="/" to="/" />
        </Switch>
      </div>
    );
  }
}

export default App;
